module.exports = __webpack_public_path__ + "img/ServiceAdvanced.8f57a8f6.svg";